<template>
  <div class="issued-pass-item">
    <div class="row">
      <div class="col-sm-5 col-xs-12">
        <b>
          <a
            class="issued-pass-item__number"
            @click="givePdfPass(issuedPass.application_id, issuedPass.personal_id, issuedPass.transport_id)"
          >
            №{{ issuedPass.pass_number }}
          </a>
          {{ timeTypeText }}
          <span v-html="period" />
        </b>
      </div>
      <div class="col-sm-4 col-xs-6">
        <v-popover v-if="visibleAutoTypeImage" trigger="hover" placement="top" style="display: inline-block">
          <template v-slot:popover>
            {{ transportMarkModelText }}
            <br>
            {{ transport.number }}
          </template>
          <img
            :src="baseUrl + '/img/icons/' + transport.type + '.png'"
            class="auto-type-icon"
            alt=""
          >
        </v-popover>
        <b>
          <router-link :to="`visitor/list?search=${issuedPass.full_name}&filterColumns=full_name`">
            {{ issuedPass.full_name }}
          </router-link>
        </b>
      </div>
      <div class="col-sm-3 col-xs-6">
        <b>
          <router-link :to="getApplicationListLinkByNumber(issuedPass.application_number, issuedPass.period_to)">
            Заявка №{{ issuedPass.application_number }}
          </router-link>
        </b>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5 col-xs-12 overflow-block">
        <span :title="issuedPass.organization_name">
          {{ issuedPass.organization_name }}
        </span>
      </div>
      <div class="col-sm-7 col-xs-12 overflow-block">
        <span :title="issuedText">
          <span style="color: #888">Выдан:</span> {{ issuedText }}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5 col-xs-3">
        <span style="color: #888">ОТИ:</span> {{ issuedPass.terminal_name }}
      </div>
      <div v-if="issuedPass.operator" class="col-sm-7 col-xs-9">
        <span style="color: #888">Оператор:</span> {{ issuedPass.operator }}
      </div>
    </div>
  </div>
</template>

<script>
import '@/common/assets/styles/issued-pass-item.scss'
import mainMixin from '@/common/mixins/mainMixin'
import PermissionsMixin from '@/common/mixins/PermissionsMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import ActionListMenuMixin from '@/common/mixins/actionListMenuMixin'
import { TimeTypes } from '@/common/enums/TimeTypes'
import moment from 'moment-timezone'
import { TransportTypes } from '@/common/enums/TransportTypes'

export default {
  name: 'IssuedPassItem',

  mixins: [mainMixin, PermissionsMixin, ActionListMenuMixin],

  props: {
    issuedPass: { type: Object }
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL
    }
  },

  computed: {
    issuedText() {
      if (this.issuedPass.guardian) {
        return this.issuedPass.guardian + ' (' + this.issuedPass.issue_date + ')'
      }

      return this.issuedPass.issue_date
    },

    timeTypeText() {
      let timeTypeText = ' '
      if (this.issuedPass.time_type === TimeTypes.ONE) {
        timeTypeText += 'разовый'
      } else if (this.issuedPass.time_type === TimeTypes.PERMANENT) {
        timeTypeText += 'постоянный'
      }

      return timeTypeText
    },

    period() {
      const outputFormat = 'DD.MM.YYYY'
      const inputFormat = 'DD.MM.YYYY'
      const periodOf = moment.tz(this.issuedPass.period_of, inputFormat, this.timezone).format(outputFormat)
      const periodTo = moment.tz(this.issuedPass.period_to, inputFormat, this.timezone).format(outputFormat)

      if (!periodOf) {
        return ''
      }
      if (!periodTo) {
        return 'с&nbsp;' + periodOf
      }
      if (this.issuedPass.time_type === 'one' && periodOf === periodTo) {
        return 'на&nbsp;' + periodOf
      }

      return 'с&nbsp;' + periodOf + '&nbsp;по&nbsp;' + periodTo
    },

    visibleAutoTypeImage() {
      return this.transport && this.transport.type !== TransportTypes.Pedestrian
    },

    transport() {
      return this.issuedPass.transport
    },

    transportMarkModelText() {
      return this.transport.mark + (this.transport.mark !== this.transport.model ? ' ' + this.transport.model : '')
    }
  },

  methods: {
    async givePdfPass(applicationId, personalId, transportId) {
      const pdfPassBlobResponse = await ApiClient.getPass(
        applicationId,
        personalId,
        transportId ?? null,
        false,
        false
      )
      this.openPdfInNewTab(pdfPassBlobResponse.data)
    },

    getApplicationListLinkByNumber(applicationNumber, periodTo) {
      const [day, month, year] = periodTo.split('.')
      const now = new Date()
      const archived = new Date(year, month - 1, day) < now.setHours(0, 0, 0, 0) ? '1' : '0'

      return `application/list?archived=${archived}&search=${applicationNumber}` +
        '&filter=all&typeFilter=all&subdivFilter=all&filterColumns=number&page=1'
    }
  }
}
</script>
